module.exports = __webpack_public_path__ + "static/media/about_background.178a004f.png";